import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'Algemeen',
    [tabs.restaurant_details]: 'Restaurantgegevens',
    [tabs.order_conversion]: 'Bestelconversie',
    [tabs.external_delivery]: 'Externe bezorging',
    [tabs.mobile_app]: 'Mobiele app',
    [tabs.customer_success_team]: 'Customer success-team',
    [tabs.onboarding_team]: 'Onboardingteam',
  },
  date_range: {
    this_month: 'Deze maand',
    last_month: 'Vorige maand',
    last_week: 'Vorige week',
    last_year: 'Vorig jaar',
    this_week: 'Deze week',
    this_year: 'Dit jaar',
    today: 'Vandaag',
    yesterday: 'Gisteren',
    all: 'Alles',
  },
};
